import { Navigate, Route, Routes } from "react-router-dom";
import { AdminAuthProvider } from "@/admin/auth/AdminAuthContext";
import { AdminLayout } from "@/admin/layout/AdminLayout";
import { LoginPage } from "@/admin/pages/LoginPage";
import { DashboardPage } from "@/admin/pages/DashboardPage";
import { ProtectedRoute } from "@/admin/routes/ProtectedRoute";
import "@/admin/admin.css";

export function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </AdminAuthProvider>
  );
}